import { z } from 'zod'
import { DateTimeStringSchema } from './common'

export const CouponDataSchema = z.object({
  id: z.number(),
  spotId: z.number().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  code: z.string().nullable(),
  image: z.string().nullable(),
  status: z.number(),
  stampLinked: z.boolean().nullable(),
  termOfUse: z.boolean().nullable(),
  termOfUseValue: z.number().nullable(),
  termOfUseType: z.number().nullable(),
  startAt: DateTimeStringSchema.nullable(),
  endAt: DateTimeStringSchema.nullable(),
  expireAt: DateTimeStringSchema.nullable(),
  createdAt: DateTimeStringSchema.nullable(),
  updatedAt: DateTimeStringSchema.nullable(),
})

export const CouponGetResponseSchema = z.object({
  coupon: CouponDataSchema.nullable(),
})

export const CouponListResponseSchema = z.object({
  coupons: z.array(CouponDataSchema),
})

/** POST /api/v2/coupons/{id} レスポンス */
export const CouponRedeemResponseSchema = z.object({
  coupon: CouponDataSchema,
  usedAt: DateTimeStringSchema.nullable(),
  transactionId: z.number(),
})

export type CouponData = z.infer<typeof CouponDataSchema>
export type CouponGetResponse = z.infer<typeof CouponGetResponseSchema>
export type CouponListResponse = z.infer<typeof CouponListResponseSchema>
export type CouponRedeemResponse = z.infer<typeof CouponRedeemResponseSchema>
